<template>
  <div style="margin: 5px 0">系统版本 V1.0.0.1</div>
</template>

<script>
export default {};
</script>

<style>
</style>